import { createFileRoute } from '@tanstack/react-router'
import { OpportunityEditor } from '../-OpportunityEditor'

export const Route = createFileRoute('/crm/opportunities/$id/')({
  component: OpportunityDetailPage,
})

function OpportunityDetailPage() {
  const { id } = Route.useParams()
  return <OpportunityEditor opportunityId={id} />
}
